import "./bio.css";
import { Unlock, Lock, GraduationCap, ArrowRightCircle } from "lucide-react";


function Bio() {
  const title = "Sobre o Prof. Nicholas Yukio";
  const image = "/foto_pessoal_pequena-768x765.jpg";
  const bgColor = '#f5fbfc';
  const reverse = false;
  return (
    <section
      className={`bio ${reverse ? 'reverse' : ''}`}
      style={{ backgroundColor: bgColor }}
    >
      <div className="bio-content">
        <div className="bio-image">
          <img src={image} alt={title} />
        </div>
        <div className="bio-text">
          <h2>{title}</h2>
            <p>Sou engenheiro eletrônico formado no ITA em 2017. </p>
            <p>Comecei a vida profissional como professor da disciplina de circuitos elétricos no ITA, onde trabalhei de 2018 até março de 2020.</p>
            <p>No início de 2020, criei meu curso online de circuitos elétricos, o Domínio Elétrico, focado em alunos de engenharia.</p>
            <p>Depois, de um simples curso, o Domínio Elétrico tornou-se este site, com muito conteúdo e recursos para o estudo de circuitos elétricos.</p>
            <p>Temos centenas de alunos no site, e muitos são alunos de diversas faculdades, públicas e privadas, mas há também alunos de cursos técnicos e profissionais já formados que querem revisar seus conhecimentos.</p>
            <p>A nossa missão aqui é: ensinar da melhor forma possível quem quer estudar sério circuitos elétricos.</p>
            <div className="de-hero-actions">
              <a href="#form" className="de-hero-cta">
                Quero ser aluno <ArrowRightCircle size={20} />
              </a>
            </div>
        </div>
      </div>
    </section>
  );
}

export default Bio;